/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  makeStyles,
  lighten,
  withStyles,
  useTheme
} from "@material-ui/core/styles";
import {
  TextField,
  InputLabel,
  Modal,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  MenuItem,
  Select,
  IconButton,
  RadioGroup,
  Radio,
  Checkbox,
  Grid,
  ListItemText,
  FormControlLabel,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  CardHeader,
  TableFooter
} from "@material-ui/core";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import { useDropzone } from "react-dropzone";
import { Image, Container, Row, Col } from "react-bootstrap";

import * as moment from "moment";

import {
  getDeptList,
  getInOutsList,
  getPositionList,
  getUserTypeList,
  getFaceList,
  getCardList,
  checkExistCard,
  getAccessList,
  registerUser,
  registerFace,
  registerCard,
  registerAccess,
  detectFace
} from "../modules/Auth/_redux/inOutsCrud";
import { random } from "lodash";

export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

const useStylesCard = makeStyles({
  card: {
    minWidth: 275
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  }
});

const useStyles1 = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1)
  },
  input: {
    display: "none"
  }
}));

const useStyles4 = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  margin: {
    margin: theme.spacing(1)
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  }
}));

const StyledTableCell4 = withStyles(theme => ({
  head: {
    backgroundColor: "#298BA8", // theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow4 = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    }
  }
}))(TableRow);

// Example 5
const useStyles52 = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3)
  },
  table: {
    minWidth: 500
  },
  tableWrapper: {
    overflowX: "auto"
  }
}));

const useStyles51 = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.5)
  }
}));

function TablePaginationActions5(props) {
  const classes = useStyles51();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  function handleFirstPageButtonClick(event) {
    onChangePage(event, 0);
  }

  function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  }

  function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  }

  function handleLastPageButtonClick(event) {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  }

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="First Page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="Previous Page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Next Page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Last Page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions5.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};

var selectedImageFile;
var selectedImageData;

function ImageDropper(props) {
  const [imageUrl, setImageUrl] = React.useState();
  const [imageFile, setImageFile] = React.useState();

  const onDrop = React.useCallback(
    acceptedFiles => {
      const file = acceptedFiles[0];
      setImageFile(file);

      // convert file to data: url
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          const fetchData = async () => {
            try {
              const result = await detectFace(reader.result);

              console.log("DETECT FACE", result);

              if (result.data.resultCode != "ok") {
                props.setTitle("Error");
                props.setErrorMsg(result.data.message);
                props.setShowSnack(true);
                return;
              }

              setImageUrl(String(reader.result));
              selectedImageData = reader.result;
              selectedImageFile = file;
            } catch (error) {
              console.log("REGISTER DEVICE", error);
              props.setTitle("Error");
              props.setErrorMsg(error.toString());
              props.setShowSnack(true);
            }
          };
          fetchData();
        },
        false
      );
      reader.readAsDataURL(file);
    },
    [setImageFile, setImageUrl]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div>
      <div {...getRootProps()}>
        {isDragActive ? (
          <p>여기에 드롭하세요...</p>
        ) : (
          <p>
            여기를 클릭해서 이미지를 선택하거나, 이미지를 드래그&드롭 하세요.
          </p>
        )}
        <input {...getInputProps()} />
      </div>
      {imageUrl && (
        <div>
          <img src={imageUrl} style={{ maxWidth: "320px" }} />
        </div>
      )}

      {imageFile ? imageFile.name : ""}
    </div>
  );
}

// var deviceList = [];
var userTypeList = [];
var deptList = [];
var positionList = [];

var accessListAll = [];
// var faceList = [];
// var cardList = [];
// var accessList = [];

export function InOutsPage() {
  // TablesExamplesPage

  var m = moment();

  var _endDt = m.format("YYYY-MM-DD");
  var _startDt = m.add(-30, "days").format("YYYY-MM-DD");

  const [refresh, setRefresh] = React.useState("");

  const [deviceName, setDeviceName] = React.useState("");
  const [deviceType, setDeviceType] = React.useState("");

  const [deviceList, setDeviceList] = React.useState([]);

  const [faceList, setFaceList] = React.useState([]);
  const [cardList, setCardList] = React.useState([]);
  const [accessList, setAccessList] = React.useState([]);

  const [email, setEmail] = React.useState("");
  const [nm, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [positionId, setPositionId] = React.useState("NN");
  const [deptId, setDeptId] = React.useState("NN");
  const [typeId, setTypeId] = React.useState("NN");
  const [userNo, setUserNo] = React.useState("");
  const [startDt, setStartDt] = React.useState(_startDt + " 00:00:00");
  const [endDt, setEndDt] = React.useState(_endDt + " 23:59:59");

  const [showAskSave, setShowAskSave] = React.useState(false);
  const [showAskDelete, setShowAskDelete] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const [open, setOpen] = React.useState(false);
  const [showNew, setShowNew] = React.useState(false);

  const [title, setTitle] = React.useState("Error");
  const [errorMsg, setErrorMsg] = React.useState("");
  const [showSnack, setShowSnack] = React.useState(false);

  // Card Dialog
  const [showNewCard, setShowNewCard] = React.useState(false);
  const [showAskSaveCard, setShowAskSaveCard] = React.useState(false);
  const [cardNo, setCardNo] = React.useState("");
  const [cardStatus, setCardStatus] = React.useState("ACTIVE");
  const [cardDescs, setCardDescs] = React.useState("");
  const [cardEndDt, setCardEndDt] = React.useState("");
  const [cardStartDt, setCardStartDt] = React.useState("");
  const [cardUserId, setCardUserId] = React.useState("");

  // Access Dialog
  const [showNewAccess, setShowNewAccess] = React.useState(false);
  const [showAskSaveAccess, setShowAskSaveAccess] = React.useState(false);
  function handleCloseNewAccess() {
    setShowNewAccess(false);
  }
  function handleShowNewAccess() {
    setShowNewAccess(true);
  }

  // Face Dialog
  const [showNewFace, setShowNewFace] = React.useState(false);
  const [showAskSaveFace, setShowAskSaveFace] = React.useState(false);

  function handleChangeFace(event) {
    console.log(event.target.value);
  }

  function handleCloseNewFace() {
    setShowAskSaveFace(false);
    setShowNewFace(false);
  }

  function handleShowNewFace() {
    setShowNewFace(true);
  }

  function handleCheckSaveFace() {
    if (selectedImageData == null) return;

    setShowAskSaveFace(true);
  }

  function handleActionSaveFace() {
    var m = moment();
    var date = m.format("YYYY-MM-DD hh:mm:ss");

    if (selectedImageData == null) return;

    setShowAskSaveFace(false);
    handleCloseNewFace();

    // faceList = [...faceList, {
    //   id: faceList.length + 100,
    //   imageFile: selectedImageFile,
    //   imageData: selectedImageData,
    //   updateDt: date
    // }]

    setFaceList([
      ...faceList,
      {
        id: faceList.length + 100,
        imageFile: selectedImageFile,
        imageData: selectedImageData,
        updateDt: date
      }
    ]);
  }

  function handleCheckSave() {
    if (nm == null || nm == "") {
      setTitle("Error");
      setErrorMsg("출입자 이름을 입력해 주세요.");
      setShowSnack(true);
      return;
    }

    if (userNo == null || userNo == "") {
      setTitle("Error");
      setErrorMsg("출입자 고유번호를 입력해 주세요.");
      setShowSnack(true);
      return;
    }
    if (email == null || email == "") {
      setTitle("Error");
      setErrorMsg("이메일을 입력해 주세요.");
      setShowSnack(true);
      return;
    }

    if (phone == null || phone == "") {
      setTitle("Error");
      setErrorMsg("핸드폰 번호를 입력해 주세요.");
      setShowSnack(true);
      return;
    }
    if (typeId == null || typeId == "" || typeId == "NN") {
      setTitle("Error");
      setErrorMsg("출입자 유형을 선택해 주세요.");
      setShowSnack(true);
      return;
    }
    if (deptId == null || deptId == "" || deptId == "NN") {
      setTitle("Error");
      setErrorMsg("출입자 부서를 선택해 주세요.");
      setShowSnack(true);
      return;
    }
    if (positionId == null || positionId == "" || positionId == "NN") {
      setTitle("Error");
      setErrorMsg("출입자 직급을 선택해 주세요.");
      setShowSnack(true);
      return;
    }

    if (accessList.length == 0) {
      setTitle("Error");
      setErrorMsg("출입자 권한을 1개 이상 추가해 주세요.");
      setShowSnack(true);
      return;
    }

    setShowAskSave(true);
  }

  function handleShowNewCard() {
    var m = moment();

    var _cardEndDt = m.format("YYYY-12-31");
    var _cardStartDt = m.format("YYYY-MM-DD");

    setCardNo("");
    setCardStatus("ACTIVE");
    setCardDescs("");
    setCardEndDt(_cardEndDt);
    setCardStartDt(_cardStartDt);

    setShowNewCard(true);
  }
  function handleCloseAskSaveCard() {
    setShowAskSaveCard(false);
  }

  function handleCloseNewCard() {
    setShowNewCard(false);
  }

  function handleActionCheckCard() {
    if (cardNo == null || cardNo == "") {
      setTitle("Error");
      setErrorMsg("카드 번호를 입력해 주세요.");
      setShowSnack(true);
      return;
    }
    if (cardDescs == null || cardDescs == "") {
      setTitle("Error");
      setErrorMsg("카드 설명을 입력해 주세요.");
      setShowSnack(true);
      return;
    }

    console.log(cardStartDt, cardEndDt);

    if (cardEndDt.localeCompare(cardStartDt) <= 0) {
      setTitle("Error");
      setErrorMsg("시작 유효일은 종료 유효일보다 먼저 지정되어야 합니다.");
      setShowSnack(true);
      return;
    }

    const fetchData = async () => {
      try {
        const result = await checkExistCard(cardNo);

        console.log("CHECK EXIST CARD", result);

        if (result.data.resultCode != "ok") {
          setTitle("Error");
          setErrorMsg(result.data.message);
          setShowSnack(true);
          return;
        }

        handleActionSaveCard();
      } catch (error) {
        console.log("REGISTER DEVICE", error);
        setTitle("Error");
        setErrorMsg(error.toString());
        setShowSnack(true);
      }
    };
    fetchData();
  }
  function handleActionSaveCard() {
    var cardStatusStr = cardStatus == "ACTIVE" ? "사용" : "미사용";

    // cardList = [...cardList, {
    //   id: faceList.length + 100,
    //   cardNo,
    //   cardStatus,
    //   cardStatusStr,
    //   startDtStr: cardStartDt,
    //   endDtStr: cardEndDt,
    //   startDt: cardStartDt + ' 00:00:00',
    //   endDt: cardEndDt + ' 23:59:59',
    // }];
    setCardList([
      ...cardList,
      {
        id: faceList.length + 100,
        cardNo,
        cardStatus,
        cardStatusStr,
        startDtStr: cardStartDt,
        endDtStr: cardEndDt,
        startDt: cardStartDt + " 00:00:00",
        endDt: cardEndDt + " 23:59:59"
      }
    ]);

    setShowNewCard(false);
  }

  function handleChangeCardNo(event) {
    setCardNo(event.target.value);
  }
  function handleChangeCardStatus(event) {
    setCardStatus(event.target.value);
  }
  function handleChangeCardDescs(event) {
    setCardDescs(event.target.value);
  }
  function handleChangeCardStartDt(event) {
    setCardStartDt(event.target.value);
  }
  function handleChangeCardEndDt(event) {
    setCardEndDt(event.target.value);
  }
  function handleChangeCardUserId(event) {
    setCardUserId(event.target.value);
  }

  function handleClickOpen(row) {
    setSelectedRow(row);
    setOpen(true);
  }

  function handleCloseNew() {
    setShowNew(false);
  }

  function handleClose() {
    setOpen(false);
  }

  function handleDelete() {
    setOpen(false);
  }

  function handleChangeDeptId(event) {
    setDeptId(event.target.value);
  }
  function handleChangeEmail(event) {
    setEmail(event.target.value);
  }
  function handleChangeName(event) {
    setName(event.target.value);
  }
  function handleChangePhone(event) {
    setPhone(event.target.value);
  }
  function handleChangePositionId(event) {
    setPositionId(event.target.value);
  }
  function handleChangeTypeId(event) {
    setTypeId(event.target.value);
  }
  function handleChangeUserNo(event) {
    setUserNo(event.target.value);
  }

  function handleChangeCardStartDt(event) {
    console.log(event.target.value);
    setCardStartDt(event.target.value);
  }
  function handleChangeCardEndDt(event) {
    console.log(event.target.value);
    setCardEndDt(event.target.value);
  }
  function handleChangeStartDt(event) {
    setStartDt(event.target.value + " 00:00:00");
  }
  function handleChangeEndDt(event) {
    setEndDt(event.target.value + " 23:59:59");
  }
  function handleCloseSnack() {
    setShowSnack(false);
  }

  function newUserButtonClick() {
    setShowNew(true);
  }

  function handleClickAskDelete(row) {
    setSelectedRow(row);
    setShowAskDelete(true);
  }

  function handleCheckSaveAccess() {
    if (right2.length == 0) {
      setTitle("Error");
      setErrorMsg("출입권한을 한 개 이상 추가해 주세요.");
      setShowSnack(true);
      return;
    }

    setShowAskSaveAccess(true);
  }

  function handleActionSaveAccess() {
    setShowAskSaveAccess(false);
    setShowNewAccess(false);
    console.log(right2);
    // updateDt, nm, id
    // right2.map(index => accessList = [...accessList, accessListAll[index]]);
    right2.map(index => setAccessList([...accessList, accessListAll[index]]));
  }

  function handleActionSave() {
    setShowAskSave(false);

    const fetchData = async () => {
      try {
        const result = await registerUser(
          deptId,
          email,
          endDt,
          nm,
          phone,
          positionId,
          startDt,
          typeId,
          userNo
        );

        console.log("REGISTER USER", result);

        if (result.data.resultCode != "ok") {
          setTitle("Error");
          setErrorMsg(result.data.message);
          setShowSnack(true);
          return;
        }

        var userId = result.data.data;

        const pushData = async () => {
          try {
            console.log("REGISTER ALL", faceList, cardList, accessList);

            for (var ii = 0; ii < faceList.length; ii++) {
              const result = await registerFace(userId, faceList[ii].imageData);

              console.log("REGISTER FACE", result);

              if (result.data.resultCode != "ok") {
                setTitle("얼굴등록 에러");
                setErrorMsg(result.data.message);
                setShowSnack(true);
                break;
              }
            }

            for (var ii = 0; ii < cardList.length; ii++) {
              const result = await registerCard(
                userId,
                cardList[ii].cardNo,
                cardList[ii].cardStatus,
                cardList[ii].descs,
                cardList[ii].endDt,
                cardList[ii].startDt
              );

              console.log("REGISTER CARD", result);

              if (result.data.resultCode != "ok") {
                setTitle("카드등록 에러");
                setErrorMsg(result.data.message);
                setShowSnack(true);
                break;
              }
            }

            if (accessList.length > 0) {
              var accessGrpIds = accessList.join(",");

              const result = await registerAccess(userId, accessGrpIds);

              console.log("REGISTER ACCESS", result);

              if (result.data.resultCode != "ok") {
                setTitle("권한등록 에러");
                setErrorMsg(result.data.message);
                setShowSnack(true);
                return;
              }
            }

            setShowNew(false);
            searchAll();
          } catch (error) {
            console.log("REGISTER DEVICE", error);
            setTitle("Error");
            setErrorMsg(error.toString());
            setShowSnack(true);
          }
        };
        pushData();
      } catch (error) {
        console.log("REGISTER DEVICE", error);
        setTitle("Error");
        setErrorMsg(error.toString());
        setShowSnack(true);
      }
    };
    fetchData();
  }

  function searchAll() {
    const fetchData = async () => {
      try {
        const resultIO = await getInOutsList();
        const resultUserType = await getUserTypeList();
        const resultDept = await getDeptList();
        const resultPosition = await getPositionList();
        const resultFace = await getFaceList();
        const resultCard = await getCardList();
        const resultAccess = await getAccessList();

        console.log("resultIO", resultIO);
        console.log("resultUserType", resultUserType);
        console.log("resultDept", resultDept);
        console.log("resultPosition", resultPosition);
        console.log("resultFace", resultFace);
        console.log("resultCard", resultCard);
        console.log("resultAccess", resultAccess);

        userTypeList = resultUserType.data.list;
        positionList = resultPosition.data.list;
        deptList = resultDept.data.list;
        // faceList = resultFace.data.list;
        // cardList = resultCard.data.list;
        accessListAll = resultAccess.data.list;

        faceList.map(face => {
          face.updateDt = face.updateDt.substr(0, 10);
        });

        cardList.map(card => {
          card.startDt = card.startDt.substr(0, 10);
          card.endDt = card.endDt.substr(0, 10);
          card.endDt = card.endDt.substr(0, 10);
          card.cardStatusStr = card.cardStatus == "ACTIVE" ? "사용" : "미사용";
        });
        accessListAll.map(access => {
          access.createDt = access.createDt.substr(0, 10);
          access.updateDt = access.updateDt.substr(0, 10);
        });

        setDeviceList([]);
        var hists = resultIO.data.list;
        var _deviceList = [];
        for (var aa = 0; aa < hists.length; aa++) {
          var hist = hists[aa];

          if (hist.createDt != null && hist.createDt != "")
            hist.startDtStr =
              hist.createDt.substr(0, 10) + " " + hist.createDt.substr(11, 5);

          if (hist.endDt != null && hist.endDt != "")
            hist.endDtStr =
              hist.endDt.substr(0, 10) + " " + hist.endDt.substr(11, 5);

          for (var ii = 0; ii < deptList.length; ii++) {
            if (hist.deptId == deptList[ii].id)
              hist["deptNm"] = deptList[ii].nm;
          }

          for (var ii = 0; ii < positionList.length; ii++) {
            if (hist.positionId == positionList[ii].id)
              hist["positionNm"] = positionList[ii].nm;
          }

          for (var ii = 0; ii < userTypeList.length; ii++) {
            if (hist.positionId == userTypeList[ii].id)
              hist["typeNm"] = userTypeList[ii].nm;
          }

          _deviceList = [..._deviceList, hist];
        }

        setDeviceList(_deviceList);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }

  function handleRemoveFace(row) {
    console.log("handleRemoveFace", row, faceList);
    for (var ii = 0; ii < faceList.length; ii++) {
      if (faceList[ii].id == row.id) {
        faceList.splice(ii, 1);
        break;
      }
    }

    setRefresh("REFRESH");
  }

  function handleRemoveCard(row) {
    for (var ii = 0; ii < cardList.length; ii++) {
      if (cardList[ii].id == row.id) {
        cardList.splice(ii, 1);
        break;
      }
    }

    setRefresh("REFRESH");
  }

  function handleRemoveAccess(row) {
    for (var ii = 0; ii < accessList.length; ii++) {
      if (accessList[ii].id == row.id) {
        accessList.splice(ii, 1);
        break;
      }
    }
    setRefresh("REFRESH");
  }

  function onHide() {}

  function handleChangeDeviceName(event, newValue) {
    setDeviceName(newValue);
  }

  function handleChangeDeviceType(event, newValue) {
    setDeviceType(newValue);
  }
  const classesCard = useStylesCard();
  const classes1 = useStyles1();
  const classes4 = useStyles4();
  const classes5 = useStyles52();

  const [page5, setPage5] = React.useState(0);
  const [rowsPerPage5, setRowsPerPage5] = React.useState(10);

  const emptyRows5 =
    rowsPerPage5 -
    Math.min(rowsPerPage5, deviceList.length - page5 * rowsPerPage5);

  function handleChangePage5(event, newPage) {
    setPage5(newPage);
  }

  function handleChangeRowsPerPage5(event) {
    setRowsPerPage5(parseInt(event.target.value, 10));
  }

  useEffect(() => {
    searchAll();
  }, []);

  function not(a, b) {
    return a.filter(value => b.indexOf(value) === -1);
  }

  function intersection(a, b) {
    return a.filter(value => b.indexOf(value) !== -1);
  }

  // Example 2
  const useStyles2 = makeStyles(theme => ({
    root: {
      margin: "auto"
    },
    cardHeader: {
      padding: theme.spacing(1, 2)
    },
    list: {
      width: 200,
      height: 230,
      backgroundColor: theme.palette.background.paper,
      overflow: "auto"
    },
    button: {
      margin: theme.spacing(0.5, 0)
    }
  }));

  function not2(a, b) {
    return a.filter(value => b.indexOf(value) === -1);
  }

  function intersection2(a, b) {
    return a.filter(value => b.indexOf(value) !== -1);
  }

  function union2(a, b) {
    return [...a, ...not2(b, a)];
  }

  const range = (from, to, step) =>
    [...Array(Math.floor((to - from) / step) + 1)].map(
      (_, i) => from + i * step
    );

  const classes2 = useStyles2();
  const [checked2, setChecked2] = React.useState([]);
  // const [left2, setLeft2] = React.useState(Array.from(Array(deviceList.length).keys()));
  const [left2, setLeft2] = React.useState(range(0, accessListAll.length, 1));
  const [right2, setRight2] = React.useState([]);

  const leftChecked2 = intersection2(checked2, left2);
  const rightChecked2 = intersection2(checked2, right2);

  const handleToggle2 = value => () => {
    const currentIndex2 = checked2.indexOf(value);
    const newChecked2 = [...checked2];

    if (currentIndex2 === -1) {
      newChecked2.push(value);
    } else {
      newChecked2.splice(currentIndex2, 1);
    }

    setChecked2(newChecked2);
  };

  const numberOfChecked2 = items => intersection2(checked2, items).length;

  const handleToggleAll2 = items => () => {
    if (numberOfChecked2(items) === items.length) {
      setChecked2(not2(checked2, items));
    } else {
      setChecked2(union2(checked2, items));
    }
  };

  const handleCheckedRight2 = () => {
    setRight2(right2.concat(leftChecked2));
    setLeft2(not2(left2, leftChecked2));
    setChecked2(not2(checked2, leftChecked2));
  };

  const handleCheckedLeft2 = () => {
    setLeft2(left2.concat(rightChecked2));
    setRight2(not2(right2, rightChecked2));
    setChecked2(not2(checked2, rightChecked2));
  };

  const customList2 = (title, items) => (
    <Card>
      <CardHeader
        className={classes2.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll2(items)}
            checked={
              numberOfChecked2(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked2(items) !== items.length &&
              numberOfChecked2(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ "aria-label": "모두 선택됨" }}
          />
        }
        title={title}
        subheader={`${numberOfChecked2(items)}/${items.length} 선택됨`}
      />
      <Divider />
      <List className={classes2.list} dense component="div" role="list">
        {items.map(value => {
          if (accessListAll[value] == null) return;

          const doorNm = accessListAll[value].nm;
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <ListItem
              key={value}
              role="listitem"
              button
              onClick={handleToggle2(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked2.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={doorNm} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  return (
    <>
      <div className="row">
        <div className="col-md-2">
          <TextField
            id="standard-name"
            label="장치이름 또는 카드번호"
            className={classes4.textField}
            onChange={handleChangeDeviceName}
            margin="normal"
          />
        </div>

        <div className="col-md-2">
          <Button
            variant="contained"
            color="secondary"
            className={classes4.button}
            onClick={searchAll}
            style={{
              position: "absolute",
              bottom: "8px",
              left: "18px"
            }}
          >
            검색
            <SearchIcon className={classes4.rightIcon} />
          </Button>
        </div>
        <div className="col-md-8">
          <Button
            variant="contained"
            color="secondary"
            className={classes4.button}
            onClick={newUserButtonClick}
            style={{
              position: "absolute",
              bottom: "8px",
              right: "18px"
            }}
          >
            출입자 등록
            <SearchIcon className={classes4.rightIcon} />
          </Button>
        </div>
      </div>

      {/*<div className="separator separator-dashed my-7"></div>*/}
      <div className="row">
        <div className="col-md-12">
          <Paper className={classes5.root}>
            <div className={classes5.tableWrapper}>
              <Table className={classes5.table}>
                <TableHead>
                  <TableRow>
                    <StyledTableCell4 align="center" style={{ width: "100px" }}>
                      출입자번호
                    </StyledTableCell4>
                    <StyledTableCell4 align="center">이름</StyledTableCell4>
                    <StyledTableCell4 align="center">핸드폰</StyledTableCell4>
                    <StyledTableCell4 align="center">타입</StyledTableCell4>
                    <StyledTableCell4 align="center">부서</StyledTableCell4>
                    <StyledTableCell4 align="center">직급</StyledTableCell4>
                    <StyledTableCell4 align="center">
                      유효 시작일
                    </StyledTableCell4>
                    <StyledTableCell4 align="center">
                      유효 종료일
                    </StyledTableCell4>
                    <StyledTableCell4 align="center"> </StyledTableCell4>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {deviceList
                    .slice(
                      page5 * rowsPerPage5,
                      page5 * rowsPerPage5 + rowsPerPage5
                    )
                    .map(row => (
                      <TableRow key={row.userNo}>
                        <TableCell component="th" scope="row" align="center">
                          {row.userNo}
                        </TableCell>

                        <TableCell align="left">{row.nm}</TableCell>
                        <TableCell align="center">{row.phone}</TableCell>
                        <TableCell align="center">{row.typeNm}</TableCell>
                        <TableCell align="center">{row.deptNm}</TableCell>
                        <TableCell align="center">{row.positionNm}</TableCell>
                        <TableCell align="center">{row.startDtStr}</TableCell>
                        <TableCell align="center">{row.endDtStr}</TableCell>

                        <TableCell align="center" style={{ padding: "0" }}>
                          <Button
                            size="small"
                            className={classes4.margin}
                            onClick={handleClickAskDelete.bind(this, row)}
                            style={{ color: "orangered", margin: 0 }}
                          >
                            <DeleteIcon className={classes4.deleteIcon} />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}

                  {emptyRows5 > 0 && (
                    <TableRow style={{ height: 48 * emptyRows5 }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      // rowsPerPageOptions={[5, 10, 25]}
                      colSpan={3}
                      count={deviceList.length}
                      rowsPerPage={rowsPerPage5}
                      page={page5}
                      /*SelectProps={{
                        inputProps: { "aria-label": "Rows per page" },
                        native: true
                      }}*/
                      onChangePage={handleChangePage5}
                      onChangeRowsPerPage={handleChangeRowsPerPage5}
                      ActionsComponent={TablePaginationActions5}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </Paper>
        </div>
      </div>

      <Dialog
        open={showSnack}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ minWidth: "320px" }}
      >
        <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSnack} color="primary" autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAskDelete}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"출입자 삭제"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            이 출입자를 삭제하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            아니오
          </Button>
          <Button onClick={handleDelete} color="primary" autoFocus>
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAskSave}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"장치 등록"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            이 출입자를 등록하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNew} color="primary">
            아니오
          </Button>
          <Button onClick={handleActionSave} color="primary" autoFocus>
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAskSaveAccess}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"장치 등록"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            이 권한을 적용하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNewAccess} color="primary">
            아니오
          </Button>
          <Button onClick={handleActionSaveAccess} color="primary" autoFocus>
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={showNew}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">출입자 등록</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ visibility: "hidden" }}>
              sldflasjdf;lajsd;lfkjas;ldkfja;lsdkfja;oiejo;aisjdf;lasdjfl;aisjdfl;ajsdf;oiajef;iljasd;fljasd;lkfjas;ldkfja;oiwefjl;asdjf;lasdjf;lkasjdf;lksajdf;ljasd;lkf
            </div>
          </DialogContentText>

          <div className="row">
            <div className="col-md-6">
              <TextField
                autoFocus
                margin="dense"
                onChange={handleChangeName}
                label="이름"
                type="text"
                fullWidth
              />
            </div>

            <div className="col-md-6">
              <TextField
                margin="dense"
                onChange={handleChangeUserNo}
                label="고유번호"
                type="text"
                fullWidth
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <TextField
                margin="dense"
                onChange={handleChangeEmail}
                label="이메일 주소"
                type="email"
                fullWidth
              />
            </div>

            <div className="col-md-6">
              <TextField
                margin="dense"
                onChange={handleChangePhone}
                label="핸드폰 번호"
                type="phone"
                fullWidth
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: "24px" }}>
            {/* <div className="col-md-4">
              <InputLabel htmlFor="age-simple">장치종류</InputLabel>
              <Select
                className={classes4.textField}
                onChange={handleChangeUserType}
                style={{ width: '100%' }}
              >
                <MenuItem value=''>선택하세요</MenuItem>
                <MenuItem value='ST'>ST</MenuItem>
                <MenuItem value='RT'>RT</MenuItem>
              </Select>
            </div> */}

            <div className="col-md-4">
              <InputLabel htmlFor="age-simple">유형</InputLabel>
              <Select
                className={classes4.textField}
                onChange={handleChangeTypeId}
                value={typeId}
                style={{ width: "100%" }}
              >
                <MenuItem value="NN">유형 선택</MenuItem>
                {userTypeList.map(item => {
                  return <MenuItem value={item.id}>{item.nm}</MenuItem>;
                })}
              </Select>
            </div>
            <div className="col-md-4">
              <InputLabel htmlFor="age-simple">부서</InputLabel>
              <Select
                className={classes4.textField}
                onChange={handleChangeDeptId}
                value={deptId}
                style={{ width: "100%" }}
              >
                <MenuItem value="NN">부서 선택</MenuItem>
                {deptList.map(item => {
                  return <MenuItem value={item.id}>{item.nm}</MenuItem>;
                })}
              </Select>
            </div>
            <div className="col-md-4">
              <InputLabel htmlFor="age-simple">직급</InputLabel>
              <Select
                className={classes4.textField}
                onChange={handleChangePositionId}
                value={positionId}
                style={{ width: "100%" }}
              >
                <MenuItem value="NN">직급 선택</MenuItem>
                {positionList.map(item => {
                  return <MenuItem value={item.id}>{item.nm}</MenuItem>;
                })}
              </Select>
            </div>
          </div>

          <div className="row" style={{ marginTop: "24px" }}>
            <div className="col-md-4">
              <TextField
                id="date"
                label="유효 시작일"
                type="date"
                defaultValue={_startDt}
                onChange={handleChangeStartDt}
                className={classes4.textField}
                InputLabelProps={{
                  shrink: true
                }}
                style={{}}
              />
            </div>

            <div className="col-md-4">
              <TextField
                id="date"
                label="유효 종료일"
                type="date"
                defaultValue={_endDt}
                onChange={handleChangeEndDt}
                className={classes4.textField}
                InputLabelProps={{
                  shrink: true
                }}
                style={{}}
              />
            </div>
          </div>

          <div className="row" style={{ marginTop: "24px" }}>
            <div className="col-md-4">
              <Card className={classesCard.card}>
                <CardContent>
                  <Typography variant="h5" component="h2">
                    얼굴 목록
                  </Typography>
                  <Table className={classesCard.table}>
                    <TableBody>
                      {faceList.map(row => (
                        <TableRow key={row.name}>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ padding: "0" }}
                          >
                            <img
                              src={
                                row.imageData || toAbsoluteUrl(row.imageFile)
                              }
                              alt="image"
                              style={{ width: "32px", margin: "0" }}
                            />
                          </TableCell>
                          <TableCell align="left" style={{ padding: "8px" }}>
                            {row.updateDt}
                          </TableCell>
                          <TableCell align="center" style={{ padding: "0" }}>
                            <Button
                              size="small"
                              className={classes4.margin}
                              onClick={handleRemoveFace.bind(this, row)}
                              style={{ color: "orangered", margin: 0 }}
                            >
                              <DeleteIcon className={classes4.deleteIcon} />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
                <CardActions>
                  <Button size="small" onClick={handleShowNewFace}>
                    사진등록
                  </Button>
                </CardActions>
              </Card>
            </div>

            <div className="col-md-4">
              <Card className={classesCard.card}>
                <CardContent>
                  <Typography variant="h5" component="h2">
                    카드 목록
                  </Typography>
                  <Table className={classesCard.table}>
                    <TableBody>
                      {cardList.map(row => (
                        <TableRow key={row.id}>
                          <TableCell align="left" style={{ padding: "4px" }}>
                            {row.cardNo}
                          </TableCell>
                          <TableCell align="left" style={{ padding: "4px" }}>
                            {row.cardStatusStr}
                          </TableCell>
                          <TableCell align="left" style={{ padding: "4px" }}>
                            {row.startDt}
                          </TableCell>
                          <TableCell align="left" style={{ padding: "4px" }}>
                            {row.endDt}
                          </TableCell>
                          <TableCell align="center" style={{ padding: "0" }}>
                            <Button
                              size="small"
                              className={classes4.margin}
                              onClick={handleRemoveCard.bind(this, row)}
                              style={{ color: "orangered", margin: 0 }}
                            >
                              <DeleteIcon className={classes4.deleteIcon} />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
                <CardActions>
                  <Button size="small" onClick={handleShowNewCard}>
                    카드등록
                  </Button>
                </CardActions>
              </Card>
            </div>

            <div className="col-md-4">
              <Card className={classesCard.card}>
                <CardContent>
                  <Typography variant="h5" component="h2">
                    출입권한 목록
                  </Typography>
                  <Table className={classesCard.table}>
                    <TableBody>
                      {accessList.map(row => (
                        <TableRow key={row.id}>
                          <TableCell align="left" style={{ padding: "4px" }}>
                            {row.nm}
                          </TableCell>
                          <TableCell align="left" style={{ padding: "4px" }}>
                            {row.updateDt}
                          </TableCell>
                          <TableCell align="center" style={{ padding: "0" }}>
                            <Button
                              size="small"
                              className={classes4.margin}
                              onClick={handleRemoveAccess.bind(this, row)}
                              style={{ color: "orangered", margin: 0 }}
                            >
                              <DeleteIcon className={classes4.deleteIcon} />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </CardContent>
                <CardActions>
                  <Button size="small" onClick={handleShowNewAccess}>
                    권한등록
                  </Button>
                </CardActions>
              </Card>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNew} color="primary">
            취소
          </Button>
          <Button onClick={handleCheckSave} color="primary">
            저장
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAskSaveCard}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"장치 등록"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            이 카드를 등록하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAskSaveCard} color="primary">
            아니오
          </Button>
          <Button onClick={handleActionSaveCard} color="primary" autoFocus>
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAskSaveFace}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"장치 등록"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            이 얼굴사진을 적용하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNewFace} color="primary">
            아니오
          </Button>
          <Button onClick={handleActionSaveFace} color="primary" autoFocus>
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showNewFace} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">얼굴 등록</DialogTitle>
        <DialogContent style={{ overflow: "hidden" }}>
          <DialogContentText>
            <div style={{ visibility: "hidden" }}>
              sldflasjdf;lajsd;lfkjas;ldkfja;lsdkfja;oiejo;aisjdf;lasdjfl;aisjdfl;ajsdf;oiajef;iljasd;fljasd;lkfjas;ldkfja;oiwefjl;asdjf;lasdjf;lkasjdf;lksajdf;ljasd;lkf
            </div>
          </DialogContentText>

          <ImageDropper
            setTitle={setErrorMsg}
            setErrorMsg={setErrorMsg}
            setShowSnack={setShowSnack}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNewFace} color="primary">
            취소
          </Button>
          <Button onClick={handleCheckSaveFace} color="primary">
            적용
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showNewCard} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">카드 등록</DialogTitle>
        <DialogContent style={{ width: "360px" }}>
          <DialogContentText>
            {/* <div style={{ visibility: 'hidden' }}><span>sldflasjdf;lajsd;lfkjas;ldkfja;lsdkfja;oiejo;aisjdf;lasdjfl;aisjdfl;ajsdf;oiajef;iljasd;fljasd;lkfjas;ldkfja;oiwefjl;asdjf;lasdjf;lkasjdf;lksajdf;ljasd;lkf
            </span></div> */}
          </DialogContentText>

          <div className="row">
            <div className="col-md-12">
              <TextField
                autoFocus
                margin="dense"
                onChange={handleChangeCardNo}
                label="카드 번호"
                type="text"
                fullWidth
              />
            </div>
          </div>

          <div className="row" style={{ marginTop: "24px" }}>
            <div className="col-md-4">
              <div style={{ lineHeight: "36px" }}>카드 상태</div>
            </div>
            <div className="col-md-8">
              <RadioGroup
                aria-label=""
                name="gender1"
                className={classes4.group}
                value={cardStatus}
                onChange={handleChangeCardStatus}
              >
                <div style={{ disaply: "flex" }}>
                  <FormControlLabel
                    value="ACTIVE"
                    control={<Radio />}
                    label="사용"
                  />
                  <FormControlLabel
                    value="STOP"
                    control={<Radio />}
                    label="정지"
                  />
                </div>
              </RadioGroup>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <TextField
                margin="dense"
                label="카드 설명"
                value={cardDescs}
                onChange={handleChangeCardDescs}
                type="email"
                fullWidth
              />
            </div>
          </div>

          <div className="row" style={{ marginTop: "64px" }}>
            <div className="col-md-6">
              <TextField
                id="date"
                label="시작일"
                type="date"
                defaultValue={cardStartDt}
                onChange={handleChangeCardStartDt}
                className={classes4.textField}
                InputLabelProps={{
                  shrink: true
                }}
                style={{
                  position: "absolute",
                  bottom: "8px"
                }}
              />
            </div>
            <div className="col-md-6">
              <TextField
                id="date"
                label="종료일"
                type="date"
                defaultValue={cardEndDt}
                onChange={handleChangeCardEndDt}
                className={classes4.textField}
                InputLabelProps={{
                  shrink: true
                }}
                style={{
                  position: "absolute",
                  bottom: "8px"
                }}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNewCard} color="primary">
            취소
          </Button>
          <Button onClick={handleActionCheckCard} color="primary">
            적용
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showNewAccess}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">출입 권한 등록</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ visibility: "hidden" }}>
              sldflasjdf;lajsd;lfkjas;ldkfja;lsdkfja;oiejo;aisjdf;lasdjfl;aisjdfl;ajsdf;oiajef;iljasd;fljasd;lkfjas;ldkfja;oiwefjl;asdjf;lasdjf;lkasjdf;lksajdf;ljasd;lkf
            </div>
          </DialogContentText>

          <div className="row">
            <div className="col-md-12">
              <Grid
                container
                spacing={2}
                justify="center"
                alignItems="center"
                className={classes2.root}
              >
                <Grid item>{customList2("전체 권한 목록", left2)}</Grid>
                <Grid item>
                  <Grid container direction="column" alignItems="center">
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes2.button}
                      onClick={handleCheckedRight2}
                      disabled={leftChecked2.length === 0}
                      aria-label="move selected right"
                    >
                      <i className="flaticon2-next" />
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes2.button}
                      onClick={handleCheckedLeft2}
                      disabled={rightChecked2.length === 0}
                      aria-label="move selected left"
                    >
                      <i className="flaticon2-back" />
                    </Button>
                  </Grid>
                </Grid>
                <Grid item>{customList2("선택된 권한 목록", right2)}</Grid>
              </Grid>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNewAccess} color="primary">
            취소
          </Button>
          <Button onClick={handleCheckSaveAccess} color="primary">
            적용
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
